<template>
    <div>
        <div class="action-machine-panel-container" v-bind:class="{ 'is-opened': actionMachineMobile }"
            style="--top-filter-container-val: 55dvh">
            <div class="d-flex d-md-none align-items-center mb-3">
                <div class="flex-fill">
                    <strong v-if="element" class="text-primary">{{ element.id }} - {{ element.name }}</strong>
                </div>
                <div>
                    <el-tooltip content="Close data filter" placement="top">
                        <el-button @click="toogleActionMachineMobile()" size="mini" type="danger" circle
                            title="Close data filter" class="ms-3 ms-md-3">
                            <div class="d-flex align-items-center">
                                <i class="el-icon-close"></i>
                            </div>
                        </el-button>
                    </el-tooltip>
                </div>
            </div>
            <div class="d-flex flex-column flex-md-row fs-5 ms-0 ms-md-auto">
                <!-- v-if="!element.isDemo" -->
                <div v-if="element">
                    <div class="action-item-btn" v-if="!element.isDemo && element.canReset">
                        <el-button type="text" :disabled="element.isNotSupport" 
                            @click="action($action.OPEN_POPUP_RESET_MACHINE)">
                            <i style="margin-right: 0.95rem" class="el-icon-refresh-right"></i>
                            <span>Reset</span>
                        </el-button>
                    </div>

                    <!-- Disconnect internet machine -->
                    <div class="action-item-btn" v-if="!element.isDemo">
                        <el-button type="text" :disabled="element.isNotSupport"
                            @click="action($action.OPEN_POPUP_ACTIVATE_SOFTWARE_LICENSE)">
                            <i style="margin-right: 0.95rem;" class="ri-certificate-2-line"></i>
                            <span>Software License</span>
                        </el-button>
                    </div>
                    <!-- Fixed rental create -->
                    <div class="action-item-btn"
                        :divided="element.canFixedRental && element.canReset"
                        v-if="!element.isDemo && element.packageId !== '28' && element.status == 2 && element.canFixedRental" >
                        <el-button type="text" :disabled="element.isNotSupport && element.status == 2"
                            @click="action($action.OPEN_POPUP_FIXED_RENTAL_CREATE)">
                            <i style="margin-right: 0.95rem" class="el-icon-plus"></i>
                            <span>Rental Plan</span>
                        </el-button>
                    </div>

                    <!-- Renewal fixed rental -->
                    <div class="action-item-btn"
                        :divided="element.canRenewalFixedRental"
                        v-if="!element.isDemo && element.canRenewalFixedRental && element.showRenewalFixedRental">
                        <el-button type="text" :disabled="element.isNotSupport" 
                            @click="action($action.OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE)">
                            <i style="margin-right: 0.95rem" class="el-icon-time"></i>
                            <span>Renewal</span>
                        </el-button>
                    </div>

                    <!-- Open port -->
                    <div class="action-item-btn" v-if="!element.isDemo && element.canOpenPort">
                        <el-button type="text" :disabled="element.isNotSupport"
                            @click="action($action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT)">
                            <i style="margin-right: 0.95rem" class="el-icon-link"></i>
                            <span>Open port</span>
                        </el-button>
                    </div>

                    <!-- Deactivate fixed rental -->
                    <div class="action-item-btn" v-if="!element.isDemo && element.canDeactivateFixedRental" >
                        <el-button type="text" @click="action($action.OPEN_POPUP_FIXED_RENTAL_DEACTIVATE)"
                            :disabled="element.isNotSupport" >
                            <i style="margin-right: 0.95rem" class="el-icon-close"></i>
                            <span>Deactivate</span>
                        </el-button>
                    </div>

                    <!-- Clone image -->
                    <div class="action-item-btn" divided>
                        <el-button type="text" 
                            v-if="!element.isDemo"
                            @click="action($action.OPEN_POPUP_CLONE_IMAGE)" 
                            :disabled="element.isNotSupport || !( element.canClone && (element.status === 3 || element.status === 6) && !(element.isSnsCreating || element.isSnsRestoring) ) ">
                            <i style="margin-right: 0.95rem" class="el-icon-copy-document"></i>
                            <span>Clone</span>
                        </el-button>
                    </div>

                    <!-- Change service package -->
                    <div class="action-item-btn" v-if="!element.isDemo && element.canChangeServicePackage"
                        @click="action($action.OPEN_POPUP_CHANGE_SERVICE_PACKAGE)">
                        <el-button type="text">
                            <i style="margin-right: 0.95rem" class="ri-arrow-left-right-line"></i>
                            <span>Change package</span>
                        </el-button>
                    </div>

                    <!-- Settings machine -->
                    <div class="action-item-btn" v-if="!element.isDemo">
                        <el-button type="text" @click="action($action.OPEN_POPUP_SETTINGS_MACHINE)">
                            <i style="margin-right: 0.95rem" class="el-icon-setting"></i>
                            <span>Settings</span>
                        </el-button>
                    </div>

                    <!-- Remove image -->
                    <div class="action-item-btn" v-if="element.canRemove" divided>
                        <el-button type="text" @click="action($action.OPEN_POPUP_REMOVE_IMAGE)">
                            <i style="margin-right: 0.95rem" class="el-icon-delete text-danger"></i>
                            <span class="text-danger">Remove</span>
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="action-machine-panel-backdrop" @click="toogleActionMachineMobile()"></div>
    </div>
</template>


<script>
// Event, Dialog
import EventBus from "@/event/EventBus";
// Constant
import { POPUP_ID, POPUP_NAME } from "@/constant/baseConstant";
export default {
    data() {
        return {
            actionMachineMobile: false,
            element: null,
        };
    },
    mounted() {
        EventBus.$on("openContextmenuMobile", ({ isOpen, machineItem }) => {
            if (isOpen) {
                this.element = machineItem;
            }
            else this.element = null;
            this.actionMachineMobile = isOpen;
        });
    },
    beforeDestroy() {
        EventBus.$off("openContextmenuMobile");
    },
    methods: {
        toogleActionMachineMobile() {
            this.actionMachineMobile = !this.actionMachineMobile
        },
        action(type) {
            switch (type) {
                case this.$action.OPEN_POPUP_EXTRA_SERVICE_OPEN_PORT:
                    EventBus.$emit("processingEventApp", {
                        event: "processOpenPopup",
                        data: {
                            type: POPUP_ID.EXTRA_SERVICE_OPEN_PORT,
                            name: POPUP_NAME.EXTRA_SERVICE_OPEN_PORT,
                            data: this.element,
                        },
                    });
                    this.actionMachineMobile = false;
                    break;
                default:
                    EventBus.$emit("cctxMnMbProcessingEvent", {
                        event: "action",
                        data: {
                            type: type,
                            data: this.element,
                        },
                    });
                    this.actionMachineMobile = false;
                    break;
            }
        },
    },
};
</script>